import { useAuthStore } from '@/stores/auth'

export default [
  // Business routes
  {
    path: '/signup/business',
    name: 'BusinessSignup',
    component: () => import('@/modules/business/views/BusinessSignup.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/auth/callbacks',
    name: 'Callbacks',
    component: () => import('@/modules/auth/views/Callbacks'),
    meta: {
      public: true,
    },
  },
  {
    path: '/business/:id',
    name: 'BusinessProfile',
    component: () => import('@/modules/business/views/Profile.vue'),
    beforeEnter: updateRepresenting,
  },
  {
    path: '/business/:id/matches',
    name: 'BusinessMatches',
    component: () => import('@/modules/business/views/Matches.vue'),
    beforeEnter: updateRepresenting,
  },
  {
    path: '/business/:id/edit',
    name: 'BusinessEdit',
    component: () => import('@/modules/business/views/BusinessEdit.vue'),
    beforeEnter: updateRepresenting,
  },
  {
    path: '/business-match/:id/',
    name: 'BusinessMatch',
    component: () => import('@/modules/business/views/MatchSingle.vue'),
  },
  // Project routes
  {
    path: '/business/:id/projects',
    name: 'BusinessProjects',
    component: () => import('@/modules/business/views/Projects.vue'),
    beforeEnter: updateRepresenting,
  },
  {
    path: '/project/:id/',
    name: 'ProjectSingle',
    component: () => import('@/modules/business/views/Project.vue'),
  },
  {
    path: '/published/project',
    name: 'projectPublished',
    component: () => import('@/views/project/PublishedView.vue'),
  },
  {
    path: '/project/:id/edit',
    name: 'ClientProjectEdit',
    component: () => import('@/views/project/ProjectForm.vue'),
  },
  // Proposal
  {
    path: '/fee-proposal/:id/',
    name: 'ProposalView',
    component: () => import('@/components/proposal/ProposalView.vue'),
  },
  {
    path: '/business/:id/fee-proposals/',
    name: 'ProposalsView',
    component: () => import('@/modules/business/views//ProjectProposals.vue'),
  },
  // Recruiter search
  {
    path: '/recruiter-search',
    name: 'RecruiterSearch',
    component: () => import('@/modules/business/views/RecruiterSearch.vue'),
  },
  {
    path: '/recruiter-search/recruiter/:id',
    name: 'RecruiterSearchProfile',
    component: () => import('@/modules/business/components/RecruiterSearchProfile.vue'),
  },
  {
    path: '/recruiter-search/agency/:id',
    name: 'AgencySearchProfile',
    component: () => import('@/modules/business/components/AgencySearchProfile.vue'),
  },
]

/**
 * Update "representing" for Admins based on business ID
 */
function updateRepresenting (to, from, next) {
  if (useAuthStore().isAdmin) {
    useAuthStore().updateBusiness(to.params.id)
  }
  next()
}
